(function () {
  const finderVersion = 'bottoms-finder-v1';
  const attributionStorageKey = 'voler_finder_attribution_v1';

  const questions = {
    rider: {
      id: 'rider',
      progressLabel: 'Rider path',
      title: 'Who are you shopping for?',
      hint: 'We’ll use this to show the exact products and constructions available for that rider.',
      options: [
        { value: 'men', label: 'Men', description: 'Men’s bibs, shorts, tights, and knicker options.' },
        { value: 'women', label: 'Women', description: 'Women’s bibs, shorts, tights, and drop-tail options.' }
      ]
    },
    conditions: {
      id: 'conditions',
      progressLabel: 'Conditions',
      title: 'What conditions are you dressing for?',
      hint: 'Conditions determine whether we start with standard-fabric shorts or thermal coverage.',
      options: [
        { value: 'warm', label: 'Warm / mild', description: 'Standard-fabric bibs and shorts for most riding conditions.' },
        { value: 'thermal', label: 'Cool / thermal', description: 'Thermal tights, cargo tights, and the men’s knicker.' }
      ]
    },
    duration: {
      id: 'duration',
      progressLabel: 'Ride time',
      title: 'How long are your typical rides?',
      hint: 'Choose the ride you do most often—not the biggest ride you might do someday.',
      options: [
        { value: 'short', label: 'Up to 2 hours', description: 'Quick spins, commutes, and shorter social rides.' },
        { value: 'medium', label: '2–4 hours', description: 'Regular weekend miles and steady training.' },
        { value: 'long', label: '4+ hours', description: 'Big days, endurance events, and all-day adventures.' }
      ]
    },
    support: {
      id: 'support',
      progressLabel: 'Support',
      title: 'How much compression feels right?',
      hint: 'Compression describes how firmly the short supports your muscles and stays in place.',
      options: [
        { value: 'easy', label: 'Easy and forgiving', description: 'Comfort first, with a lighter hold.' },
        { value: 'balanced', label: 'Balanced support', description: 'Secure and supportive without feeling aggressive.' },
        { value: 'firm', label: 'Firm performance fit', description: 'A close, structured feel that stays locked in.' },
        { value: 'unsure', label: 'I’m not sure', description: 'Show me the most versatile starting point.' }
      ]
    },
    storage: {
      id: 'storage',
      progressLabel: 'Storage',
      title: 'Do you want pockets on your bottoms?',
      hint: 'Storage refines the construction after ride time and support establish the family.',
      options: [
        { value: 'clean', label: 'Clean silhouette', description: 'Traditional bibs or shorts without leg pockets.' },
        { value: 'cargo', label: 'Cargo storage', description: 'Leg pockets for a phone, food, or ride essentials.' },
        { value: 'either', label: 'Either works', description: 'Prioritize comfort and support over storage.' }
      ]
    },
    padding: {
      id: 'padding',
      progressLabel: 'Thermal setup',
      title: 'Do you want a chamois in your thermal bottom?',
      hint: 'Padded tights are ride-ready; unpadded tights work as a thermal layer or for other activities.',
      options: [
        { value: 'padded', label: 'Padded', description: 'A built-in cycling chamois for cold-weather rides.' },
        { value: 'unpadded', label: 'Unpadded', description: 'A versatile thermal layer without a chamois.' },
        { value: 'either', label: 'Either works', description: 'Show me the strongest thermal starting points.' }
      ]
    }
  };

  const thermalStorageQuestion = {
    id: 'storage',
    progressLabel: 'Thermal storage',
    title: 'Does cargo storage matter?',
    hint: 'Voler’s padded full-length thermal tight includes cargo storage; the men’s knicker keeps a cleaner silhouette.',
    options: [
      { value: 'cargo', label: 'Yes, I want cargo', description: 'Prioritize thermal tights with leg pockets.' },
      { value: 'either', label: 'No preference', description: 'Let padding and coverage determine the result.' }
    ]
  };

  const flexibleThermalStorageQuestion = {
    ...thermalStorageQuestion,
    options: [
      { value: 'cargo', label: 'Cargo storage', description: 'Prioritize thermal tights with leg pockets.' },
      { value: 'clean', label: 'Clean silhouette', description: 'Prioritize layering tights or the men’s knicker.' },
      { value: 'either', label: 'Either works', description: 'Show me the strongest thermal starting points.' }
    ]
  };

  const warmFamilies = {
    peloton: {
      label: 'Peloton',
      compression: 2,
      scores: {
        duration: { short: 5, medium: 2, long: 0 },
        support: { easy: 5, balanced: 2, firm: 0, unsure: 3 },
        storage: { clean: 2, cargo: 0, either: 1 }
      },
      reason: 'A comfortable, lighter-compression starting point for everyday miles and shorter rides.'
    },
    escape: {
      label: 'Escape',
      compression: 3,
      scores: {
        duration: { short: 2, medium: 5, long: 3 },
        support: { easy: 2, balanced: 5, firm: 0, unsure: 4 },
        storage: { clean: 2, cargo: 0, either: 1 }
      },
      reason: 'A versatile balance of comfort and support for regular riding and longer days.'
    },
    'black-label': {
      label: 'Black Label',
      compression: 4,
      scores: {
        duration: { short: 0, medium: 3, long: 5 },
        support: { easy: 0, balanced: 3, firm: 5, unsure: 2 },
        storage: { clean: 2, cargo: 1, either: 2 }
      },
      reason: 'High support and a close performance fit for riders who want a locked-in feel on bigger days.'
    },
    super: {
      label: 'Super',
      compression: 5,
      scores: {
        duration: { short: 0, medium: 2, long: 5 },
        support: { easy: 0, balanced: 2, firm: 5, unsure: 1 },
        storage: { clean: 1, cargo: 2, either: 2 }
      },
      reason: 'Maximum support for long rides, with streamlined and cargo-focused constructions.'
    }
  };

  const warmProducts = {
    peloton: {
      men: { bib: 'peloton-men-bib', short: 'peloton-men-short' },
      women: { bib: 'peloton-women-bib', short: 'peloton-women-short' }
    },
    escape: {
      men: { bib: 'escape-men-bib', short: 'escape-men-short' },
      women: { bib: 'escape-women-bib', short: 'escape-women-short' }
    },
    'black-label': {
      men: { bib: 'black-label-men-bib', short: 'black-label-men-short', cargo: 'black-label-men-cargo' },
      women: { bib: 'black-label-women-bib', short: 'black-label-women-short', cargo: 'black-label-women-cargo' }
    },
    super: {
      men: { bib: 'super-men-bib', cargo: 'super-men-cargo' },
      women: { bib: 'super-women-bib', cargo: 'super-women-cargo' }
    }
  };

  const warmSpecialProducts = [
    {
      productKey: 'shift-escape-men-bib',
      familyLabel: 'Escape',
      riders: ['men'],
      durations: ['medium'],
      supports: ['balanced', 'unsure'],
      storages: ['clean', 'either'],
      type: 'bib'
    },
    {
      productKey: 'shift-escape-men-cargo',
      familyLabel: 'Escape',
      riders: ['men'],
      durations: ['medium'],
      supports: ['balanced', 'unsure'],
      storages: ['cargo', 'either'],
      type: 'cargo'
    },
    {
      productKey: 'shift-pace-men-bib',
      familyLabel: 'Pace',
      riders: ['men'],
      durations: ['medium', 'long'],
      supports: ['balanced', 'unsure'],
      storages: ['clean', 'either'],
      type: 'bib'
    },
    {
      productKey: 'escape-knicker-men',
      familyLabel: 'Escape',
      riders: ['men'],
      durations: ['medium', 'long'],
      supports: ['balanced', 'unsure'],
      storages: ['clean', 'either'],
      type: 'knicker'
    }
  ];

  const thermalFamilies = {
    'thermal-cargo': {
      label: 'Cargo Thermal',
      riders: ['men', 'women'],
      padding: 'padded',
      storage: 'cargo',
      products: { men: 'thermal-cargo-men', women: 'thermal-cargo-women' },
      reason: 'Ride-ready Artico X thermal protection with a built-in chamois and leg storage.'
    },
    'thermal-layering': {
      label: 'Layering Tight',
      riders: ['men', 'women'],
      padding: 'unpadded',
      storage: 'clean',
      products: { men: 'thermal-layering-men', women: 'thermal-layering-women' },
      reason: 'An unpadded Artico X thermal layer for cycling, running, or added cold-weather coverage.'
    },
    'thermal-knicker': {
      label: 'Thermal Knicker',
      riders: ['men'],
      padding: 'padded',
      storage: 'clean',
      products: { men: 'thermal-knicker-men' },
      reason: 'A padded men’s thermal knicker for riders who want warmth below the knee without a full tight.'
    },
    'jet-thermal': {
      label: 'Jet Thermal',
      riders: ['men'],
      padding: 'unpadded',
      storage: 'clean',
      products: { men: 'jet-layering-men' },
      reason: 'An unpadded full-length thermal layer for cold-weather riding and other outdoor use.'
    }
  };

  const labels = {
    rider: { men: 'Men', women: 'Women' },
    conditions: { warm: 'Warm / mild', thermal: 'Cool / thermal' },
    duration: { short: 'Up to 2 hours', medium: '2–4 hours', long: '4+ hours' },
    support: { easy: 'Easy and forgiving', balanced: 'Balanced support', firm: 'Firm performance fit', unsure: 'Unsure' },
    storage: { clean: 'Clean silhouette', cargo: 'Cargo storage', either: 'No storage preference' },
    padding: { padded: 'Padded', unpadded: 'Unpadded', either: 'Either padding setup' }
  };

  function initFinder(root) {
    if (!root || root.dataset.finderReady === 'true') return;
    root.dataset.finderReady = 'true';

    const form = root.querySelector('[data-finder-form]');
    const question = root.querySelector('[data-finder-question]');
    const hint = root.querySelector('[data-finder-hint]');
    const options = root.querySelector('[data-finder-options]');
    const back = root.querySelector('[data-finder-back]');
    const resultsBack = root.querySelector('[data-results-back]');
    const results = root.querySelector('[data-finder-results]');
    const restart = root.querySelector('[data-finder-restart]');
    const progressWrap = root.querySelector('[data-finder-progress-wrap]');
    const progress = root.querySelector('[data-finder-progress]');
    const progressBar = root.querySelector('[data-finder-progress-bar]');
    const step = root.querySelector('[data-finder-step]');
    const progressLabel = root.querySelector('[data-finder-progress-label]');
    const resultsHeading = root.querySelector('[data-results-heading]');
    const resultsSummary = root.querySelector('[data-results-summary]');
    const resultGrid = root.querySelector('[data-result-grid]');
    const resultProducts = root.querySelector('[data-result-products]');
    const resultProductLabel = root.querySelector('[data-results-product-label]');
    const emptyResults = root.querySelector('[data-results-empty]');
    const emptyHeading = root.querySelector('[data-results-empty-heading]');
    const emptyCopy = root.querySelector('[data-results-empty-copy]');
    const intro = root.querySelector('.voler-finder__intro');
    const sectionId = root.dataset.sectionId || 'voler';
    const analyticsEnabled = root.dataset.finderAnalyticsEnabled === 'true';

    if (!form || !question || !options || !results || !resultsBack) return;

    let current = 0;
    let advanceTimer;
    let engagedAt = 0;
    let startTracked = false;
    const completedSignatures = new Set();
    const answers = {};
    const selectionDelay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 160;

    function getSessionId() {
      try {
        let sessionId = window.sessionStorage.getItem('voler_finder_session_id');
        if (!sessionId) {
          sessionId = window.crypto && window.crypto.randomUUID
            ? window.crypto.randomUUID()
            : `vf-${Date.now()}-${Math.random().toString(36).slice(2)}`;
          window.sessionStorage.setItem('voler_finder_session_id', sessionId);
        }
        return sessionId;
      } catch (_) {
        return `vf-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      }
    }

    const finderSessionId = getSessionId();

    function normalizedAnswers() {
      return {
        rider: answers.rider || null,
        conditions: answers.conditions || null,
        duration: answers.duration || null,
        support: answers.support || null,
        storage: answers.storage || null,
        padding: answers.padding || null
      };
    }

    function commonAnalyticsFields() {
      return {
        finder_version: finderVersion,
        finder_category: 'bottoms',
        finder_session_id: finderSessionId,
        page_path: window.location.pathname,
        rider: answers.rider || null,
        conditions: answers.conditions || null,
        elapsed_ms: engagedAt ? Math.round((Date.now() - engagedAt) / 100) * 100 : 0
      };
    }

    function publishAnalytics(eventName, fields) {
      const payload = { event: eventName, ...commonAnalyticsFields(), ...fields };

      root.dispatchEvent(new CustomEvent('voler:finder-analytics', {
        bubbles: true,
        detail: payload
      }));

      if (!analyticsEnabled) return payload;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      return payload;
    }

    function saveAttribution(fields) {
      try {
        window.sessionStorage.setItem(attributionStorageKey, JSON.stringify({
          finder_version: finderVersion,
          answers: normalizedAnswers(),
          ...fields
        }));
      } catch (_) {
        // The Finder must remain usable when session storage is unavailable.
      }
    }

    function getFlow() {
      const flow = [questions.rider, questions.conditions];

      if (answers.conditions === 'warm') {
        flow.push(questions.duration, questions.support, questions.storage);
      }

      if (answers.conditions === 'thermal') {
        flow.push(questions.padding);
        if (answers.padding === 'padded') flow.push(thermalStorageQuestion);
        if (answers.padding === 'either') flow.push(flexibleThermalStorageQuestion);
      }

      return flow;
    }

    function expectedTotal() {
      if (answers.conditions === 'warm') return 5;
      if (answers.conditions === 'thermal' && answers.padding === 'unpadded') return 3;
      if (answers.conditions === 'thermal') return 4;
      return 5;
    }

    function renderQuestion(shouldFocus) {
      const flow = getFlow();
      const item = flow[current];
      const total = expectedTotal();
      const percent = Math.round(((current + 1) / total) * 100);

      root.dataset.finderState = 'question';
      question.textContent = item.title;
      hint.textContent = item.hint;
      step.textContent = `Step ${current + 1} of ${total}`;
      progressLabel.textContent = item.progressLabel;
      progress.setAttribute('aria-valuemax', String(total));
      progress.setAttribute('aria-valuenow', String(current + 1));
      progressBar.style.width = `${percent}%`;
      back.hidden = current === 0;
      options.dataset.optionCount = String(item.options.length);
      delete root.dataset.transitioning;

      options.innerHTML = item.options.map((option) => {
        const id = `${sectionId}-${item.id}-${option.value}`;
        const selected = answers[item.id] === option.value;
        return `<button class="voler-finder__option" id="${id}" type="button" data-option-value="${option.value}" aria-pressed="${selected}">
          <span class="voler-finder__option-content">
            <span class="voler-finder__option-title bold">${option.label}</span>
            <span class="voler-finder__option-description text-subdued">${option.description}</span>
          </span>
        </button>`;
      }).join('');

      if (shouldFocus) question.focus();
    }

    function rankWarmFamilies() {
      const ranked = Object.entries(warmFamilies)
        .filter(([id, family]) => {
          if (id === 'peloton' && answers.duration === 'long') return false;
          if (answers.support === 'firm' && family.compression < 4) return false;
          if (['black-label', 'super'].includes(id) && answers.support === 'easy') return false;
          return true;
        })
        .filter(([id]) => answers.storage !== 'cargo' || warmProducts[id][answers.rider].cargo)
        .map(([id, family]) => {
          const score = ['duration', 'support', 'storage'].reduce((total, answerId) => {
            return total + (family.scores[answerId][answers[answerId]] || 0);
          }, 0);
          return { id, label: family.label, score, reason: family.reason };
        })
        .sort((a, b) => b.score - a.score);

      if (ranked.length === 0) return [];

      const threshold = Math.max(4, ranked[0].score - 6);
      return ranked.filter((item) => item.score >= threshold).slice(0, 3);
    }

    function rankThermalFamilies() {
      return Object.entries(thermalFamilies)
        .filter(([, family]) => family.riders.includes(answers.rider))
        .filter(([, family]) => answers.padding === 'either' || family.padding === answers.padding)
        .filter(([, family]) => !answers.storage || answers.storage === 'either' || family.storage === answers.storage)
        .map(([id, family]) => {
          let score = 0;
          if (answers.padding === family.padding) score += 3;
          if (answers.storage === family.storage) score += 2;
          return { id, label: family.label, productKey: family.products[answers.rider], score, reason: family.reason };
        })
        .sort((a, b) => b.score - a.score)
        .slice(0, 4);
    }

    function resolveWarmProducts() {
      if (answers.support === 'unsure' && answers.storage === 'cargo') {
        const performanceCargo = ['black-label', 'super'].map((familyId) => ({
          productKey: warmProducts[familyId][answers.rider].cargo,
          familyLabel: warmFamilies[familyId].label,
          resultType: 'match'
        }));
        const shiftCargo = warmSpecialProducts
          .filter((product) => product.type === 'cargo')
          .filter((product) => product.riders.includes(answers.rider))
          .filter((product) => product.durations.includes(answers.duration))
          .filter((product) => product.supports.includes(answers.support))
          .filter((product) => product.storages.includes(answers.storage))
          .map((product) => ({ ...product, resultType: 'match' }));
        return [...shiftCargo, ...performanceCargo];
      }

      const families = rankWarmFamilies();
      const productTypes =
        answers.storage === 'cargo'
          ? ['cargo']
          : answers.storage === 'either'
            ? ['bib', 'short', 'knicker', 'cargo']
            : ['bib', 'short', 'knicker'];

      const matches = productTypes.flatMap((type) => {
        const familyMatches = families
          .filter((family) => warmProducts[family.id][answers.rider][type])
          .map((family) => ({
            productKey: warmProducts[family.id][answers.rider][type],
            familyLabel: family.label,
            resultType: 'match'
          }));
        const specialMatches = warmSpecialProducts
          .filter((product) => product.type === type)
          .filter((product) => product.riders.includes(answers.rider))
          .filter((product) => product.durations.includes(answers.duration))
          .filter((product) => product.supports.includes(answers.support))
          .filter((product) => product.storages.includes(answers.storage))
          .map((product) => ({
            productKey: product.productKey,
            familyLabel: product.familyLabel,
            resultType: 'match'
          }));
        return [...familyMatches, ...specialMatches];
      });

      if (matches.length > 0 || answers.support !== 'easy' || answers.storage !== 'cargo') return matches;

      return [{
        productKey: warmProducts['black-label'][answers.rider].cargo,
        familyLabel: warmFamilies['black-label'].label,
        resultType: 'closest-alternative'
      }];
    }

    function resolveThermalProducts() {
      return rankThermalFamilies().map((result) => ({
        productKey: result.productKey,
        familyLabel: result.label,
        resultType: 'match'
      }));
    }

    function answerSummary() {
      const selections = [labels.rider[answers.rider], labels.conditions[answers.conditions]];
      if (answers.conditions === 'warm') {
        selections.push(labels.duration[answers.duration], labels.support[answers.support], labels.storage[answers.storage]);
      } else {
        selections.push(labels.padding[answers.padding]);
        if (answers.storage) selections.push(labels.storage[answers.storage]);
      }
      return `You chose ${selections.filter(Boolean).join(', ')}.`;
    }

    function showResults() {
      const candidates = answers.conditions === 'thermal' ? resolveThermalProducts() : resolveWarmProducts();
      const visibleMatches = [];
      root.dataset.finderState = 'results';
      root.querySelectorAll('[data-product-key]').forEach((card) => {
        card.hidden = true;
        delete card.dataset.resultType;
      });

      candidates.forEach((result) => {
        const card = root.querySelector(`[data-product-key="${result.productKey}"]`);
        if (!card) return;
        visibleMatches.push(result);
        card.hidden = false;
        card.dataset.resultType = result.resultType;
        resultGrid.appendChild(card);
        card.querySelector('[data-card-family]').textContent = result.familyLabel;
      });

      const hasClosestAlternative = visibleMatches.some((result) => result.resultType === 'closest-alternative');
      const exactMatchCount = visibleMatches.filter((result) => result.resultType === 'match').length;
      const alternativeCount = visibleMatches.filter((result) => result.resultType === 'closest-alternative').length;
      const resultType = exactMatchCount > 0
        ? 'exact_match'
        : alternativeCount > 0
          ? 'closest_alternative'
          : 'no_match';
      const productKeys = visibleMatches.map((result) => result.productKey);
      const completionSignature = JSON.stringify({ answers: normalizedAnswers(), resultType, productKeys });
      resultProducts.hidden = visibleMatches.length === 0;
      emptyResults.hidden = visibleMatches.length !== 0 && !hasClosestAlternative;
      if (resultProductLabel) {
        resultProductLabel.textContent = hasClosestAlternative ? 'CLOSEST ALTERNATIVE' : 'PRODUCTS TO COMPARE';
      }
      if (emptyHeading) emptyHeading.textContent = 'No confident match';
      if (emptyCopy) {
        emptyCopy.textContent = hasClosestAlternative
          ? 'Voler does not currently offer a cargo bottom with an easy, forgiving compression level. Black Label Cargo is the closest available option, but its 4 / 5 compression will feel firmer than you selected.'
          : 'Try going back and choosing a different support or storage preference, or use the complete bottoms guide for a broader comparison.';
      }
      resultsSummary.textContent = hasClosestAlternative
        ? `${answerSummary()} We don’t have an exact product match, but we found the closest available alternative.`
        : visibleMatches.length
        ? `${answerSummary()} We found ${visibleMatches.length} ${visibleMatches.length === 1 ? 'product' : 'products'} to compare, ordered by style.`
        : `${answerSummary()} We don’t have a product we can confidently recommend for that combination.`;

      if (!completedSignatures.has(completionSignature)) {
        completedSignatures.add(completionSignature);
        const completionFields = {
          ...normalizedAnswers(),
          result_type: resultType,
          exact_match_count: exactMatchCount,
          alternative_count: alternativeCount,
          product_keys: productKeys
        };
        publishAnalytics('voler_finder_complete', completionFields);
        if (exactMatchCount === 0) {
          publishAnalytics('voler_finder_no_match', completionFields);
        }
        saveAttribution({
          result_type: resultType,
          exact_match_count: exactMatchCount,
          alternative_count: alternativeCount,
          product_keys: productKeys
        });
      }
      form.hidden = true;
      progressWrap.hidden = true;
      results.hidden = false;
      if (intro) intro.scrollIntoView({ block: 'start' });
      resultsHeading.focus({ preventScroll: true });
    }

    function selectAnswer(value) {
      const item = getFlow()[current];
      if (!engagedAt) engagedAt = Date.now();
      answers[item.id] = value;

      if (!startTracked) {
        startTracked = true;
        publishAnalytics('voler_finder_start', {
          question_id: item.id,
          answer_id: value
        });
      }
      publishAnalytics('voler_finder_answer', {
        step_number: current + 1,
        question_id: item.id,
        answer_id: value
      });

      if (item.id === 'conditions') {
        ['duration', 'support', 'storage', 'padding'].forEach((key) => delete answers[key]);
      }
      if (item.id === 'padding') delete answers.storage;

      options.querySelectorAll('[data-option-value]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.optionValue === value));
      });

      root.dataset.transitioning = 'true';
      window.clearTimeout(advanceTimer);
      advanceTimer = window.setTimeout(() => {
        const nextFlow = getFlow();
        if (current < nextFlow.length - 1) {
          current += 1;
          renderQuestion(true);
        } else {
          showResults();
        }
      }, selectionDelay);
    }

    options.addEventListener('click', (event) => {
      const option = event.target.closest('[data-option-value]');
      if (!option || !options.contains(option)) return;
      selectAnswer(option.dataset.optionValue);
    });

    back.addEventListener('click', () => {
      if (current === 0) return;
      window.clearTimeout(advanceTimer);
      current -= 1;
      renderQuestion(true);
    });

    resultsBack.addEventListener('click', () => {
      results.hidden = true;
      form.hidden = false;
      progressWrap.hidden = false;
      renderQuestion(true);
    });

    restart.addEventListener('click', () => {
      window.clearTimeout(advanceTimer);
      Object.keys(answers).forEach((key) => delete answers[key]);
      current = 0;
      results.hidden = true;
      form.hidden = false;
      progressWrap.hidden = false;
      renderQuestion(true);
    });

    resultGrid.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      const card = link && link.closest('[data-product-key]');
      if (!link || !card || card.hidden) return;

      const visibleCards = Array.from(resultGrid.querySelectorAll('[data-product-key]:not([hidden])'));
      const resultType = card.dataset.resultType === 'closest-alternative'
        ? 'closest_alternative'
        : 'exact_match';
      const clickFields = {
        ...normalizedAnswers(),
        product_key: card.dataset.productKey,
        product_handle: card.dataset.productHandle,
        result_type: resultType,
        result_position: visibleCards.indexOf(card) + 1
      };
      publishAnalytics('voler_finder_result_click', clickFields);
      saveAttribution({
        result_type: resultType,
        selected_product_key: card.dataset.productKey,
        selected_product_handle: card.dataset.productHandle
      });
    });

    renderQuestion(false);
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-voler-finder]').forEach(initFinder);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
